import { DIALOG_TYPE } from '@spartacus/storefront';

import { LAUNCH_CALLER as SPARTACUS_CALLER } from '@spartacus/storefront';
import { BackorderCartModalComponent } from '../spartacus/features/cart/backorder-cart-modal/backorder-cart-modal.component';
import { DeleteCartModalComponent } from '../spartacus/features/cart/cart-details/cart-delete/delete-cart-modal/delete-cart-modal.component';
import { SaveCartModalComponent } from '../spartacus/features/cart/cart-totals/save-cart-modal/save-cart-modal.component';
import { QuickOrderClearModalComponent } from '../spartacus/features/cart/quick-order/quick-order-clear-modal/quick-order-clear-modal.component';
import { QuickOrderSubmitModalComponent } from '../spartacus/features/cart/quick-order/quick-order-submit-modal/quick-order-sumbit-modal.component';
import { EditCartModalComponent } from '../spartacus/features/cart/saved-cart-details/saved-cart-overview/edit-cart-modal/edit-cart-modal.component';
import { SavedCartsListDeleteModalComponent } from '../spartacus/features/cart/saved-carts-list/saved-carts-list-delete-modal/saved-carts-list-delete-modal.component';
import { ErrorListModalComponent } from '../spartacus/features/cart/saved-carts-list/saved-carts-list-desc-cell/error-list-modal/error-list-modal.component';
import { SavedCartsListRestoreModalComponent } from '../spartacus/features/cart/saved-carts-list/saved-carts-list-restore-modal/saved-carts-list-restore-modal.component';
import { IframeContainerModalComponent } from '../spartacus/features/iframe/iframe-container-modal/iframe-container-modal.component';
import { ConfirmationPersonalInfoComponent } from '../spartacus/features/myaccount/myaccount-personal-info/confirmation-personal-info/confirmation-personal-info.component';
import { RequestDeletionModalComponent } from '../spartacus/features/myaccount/myaccount-personal-info/request-deletion-modal/request-deletion-modal.component';
import { MyaccAddressModalComponent } from '../spartacus/features/myaccount/myaccount-personalinfo-address/myacc-address-modal/myacc-address-modal.component';
import { BillingAddressModalComponent } from '../spartacus/features/myaccount/myaccount-personalinfo-address/myaccount-billing-address/billing-address-modal/billing-address-modal.component';
import { RequestNewDeliveryAddrModalComponent } from '../spartacus/features/myaccount/myaccount-personalinfo-address/request-new-delivery-addr-modal/request-new-delivery-addr-modal.component';
import { CancelEditOrderModalComponent } from '../spartacus/features/myaccount/order-details/cancel-edit-order-modal/cancel-edit-order-modal.component';
import { NotifyMeModalComponent } from '../spartacus/features/product/notify-me/notify-me-modal/notify-me-modal.component';
import { ProductImageModalComponent } from '../spartacus/features/product/product-image-modal/product-image-modal.component';
import { ProductListGridModalComponent } from '../spartacus/features/product/shimano-product-list/product-list-grid-modal/product-list-grid-modal.component';

export const CUSTOM_LAUNCH_CALLER = {
  // OOTB SPARTACUS LAUNCH CALLER
  ...SPARTACUS_CALLER,
  // MY ACCOUNTS
  REQUEST_DELETE_ACCOUNT: 'REQUEST_DELETE_ACCOUNT',
  REQUEST_NEW_DELIVERY_ADDRESS: 'REQUEST_NEW_DELIVERY_ADDRESS',
  DELETE_DELIVERY_ADDRESS: 'DELETE_DELIVERY_ADDRESS',
  CHANGE_BILLING_ADDRESS: 'CHANGE_BILLING_ADDRESS',
  CONFIRM_PERSONAL_INFO: 'CONFIRM_PERSONAL_INFO',
  // SAVED CARTS
  DELETE_SAVED_CART: 'DELETE_SAVED_CART',
  RESTORE_SAVED_CART: 'RESTORE_SAVED_CART',
  EDIT_SAVED_CART_DETAILS: 'EDIT_SAVED_CART_DETAILS',
  OPEN_ERROR: 'OPEN_ERROR',
  // CART
  SAVE_CART: 'SAVE_CART',
  DELETE_CART: 'DELETE_CART',
  // QUICK ORDER
  CLEAR_MODAL: 'CLEAR_MODAL',
  SUBMIT_MODAL: 'SUBMIT_MODAL',
  // QUICK ORDER / ADD TO CART / EV
  BACKORDER_CART_MODAL: 'BACKORDER_CART_MODAL',
  // ORDER FORM
  ORDER_FORM_PRODUCT_IMAGE: 'ORDER_FORM_PRODUCT_IMAGE',
  NOTIFY_ME_MODAL: 'NOTIFY_ME_MODAL',
  // ORDER DETAILS
  CANCEL_EDIT_ORDER: 'CANCEL_EDIT_ORDER',
  // CONTAINERS
  IFRAME_CONTAINER: 'IFRAME_CONTAINER',
  // PLP GRID VIEW
  PLP_GRID_CART_MODAL: 'PLP_GRID_CART_MODAL',
};

export const LaunchDialogModalLayoutConfig = {
  MyAccounts: {
    launch: {
      REQUEST_DELETE_ACCOUNT: {
        inlineRoot: true,
        component: RequestDeletionModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      REQUEST_NEW_DELIVERY_ADDRESS: {
        inlineRoot: true,
        component: RequestNewDeliveryAddrModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      DELETE_DELIVERY_ADDRESS: {
        inlineRoot: true,
        component: MyaccAddressModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      CHANGE_BILLING_ADDRESS: {
        inlineRoot: true,
        component: BillingAddressModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      CONFIRM_PERSONAL_INFO: {
        inlineRoot: true,
        component: ConfirmationPersonalInfoComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  SavedCarts: {
    launch: {
      DELETE_SAVED_CART: {
        inlineRoot: true,
        component: SavedCartsListDeleteModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      RESTORE_SAVED_CART: {
        inlineRoot: true,
        component: SavedCartsListRestoreModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      EDIT_SAVED_CART_DETAILS: {
        inlineRoot: true,
        component: EditCartModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      OPEN_ERROR: {
        inlineRoot: true,
        component: ErrorListModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  Carts: {
    launch: {
      SAVE_CART: {
        inlineRoot: true,
        component: SaveCartModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      DELETE_CART: {
        inlineRoot: true,
        component: DeleteCartModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  QuickOrder: {
    launch: {
      CLEAR_MODAL: {
        inlineRoot: true,
        component: QuickOrderClearModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      SUBMIT_MODAL: {
        inlineRoot: true,
        component: QuickOrderSubmitModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  BackOrderCart: {
    launch: {
      BACKORDER_CART_MODAL: {
        inlineRoot: true,
        component: BackorderCartModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  OrderForm: {
    launch: {
      ORDER_FORM_PRODUCT_IMAGE: {
        inlineRoot: true,
        component: ProductImageModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
      NOTIFY_ME_MODAL: {
        inlineRoot: true,
        component: NotifyMeModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  OrderHistory: {
    launch: {
      CANCEL_EDIT_ORDER: {
        inlineRoot: true,
        component: CancelEditOrderModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  Containers: {
    launch: {
      IFRAME_CONTAINER: {
        inlineRoot: true,
        component: IframeContainerModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
  PlpGridCart: {
    launch: {
      PLP_GRID_CART_MODAL: {
        inlineRoot: true,
        component: ProductListGridModalComponent,
        dialogType: DIALOG_TYPE.DIALOG,
        multi: true,
      },
    },
  },
};
